<fgb-mobile-header-bar [title]="'quiz.page.title' | translate" [showPoints]="true" [link]="'/games'"></fgb-mobile-header-bar>
<div class="game-layout-banner pb-0">
  <div class="container" fgbAnimateOnScroll>
    <a class="games-back-btn d-lg-flex d-none text-white" [routerLink]="['/games']">
      <i class="material-icons">chevron_left</i>
      <span>{{ 'games.back.button' | translate }}</span>
    </a>
    <div class="game-banner-img">
      @if(isLeaderboard){
      <img src="assets/images/games/leaderboard.png" alt="" />

      }@else {
      <img src="assets/images/games/TriviaBanner.jpg" alt="" />

      }
    </div>
    <div class="pt-lg-3 pt-2 pb-3 pb-lg-0">
      <fgb-route-nav>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'quiz.nav.play' | translate }}</label>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia/leaderboard']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'quiz.nav.leaderboard' | translate }}</label>
        </a>
        <!-- <a
          class="nav-item"
          [routerLink]="['/games/trivia/how']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'quiz.nav.how' | translate }}</label>
        </a> -->
      </fgb-route-nav>
    </div>
  </div>
</div>

<div class="mobile-content-wrapper">
  <router-outlet></router-outlet>
</div>
